import { render, staticRenderFns } from "./modalLenguaje.vue?vue&type=template&id=b615a7b4&scoped=true"
import script from "./modalLenguaje.vue?vue&type=script&lang=js"
export * from "./modalLenguaje.vue?vue&type=script&lang=js"
import style0 from "./modalLenguaje.vue?vue&type=style&index=0&id=b615a7b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b615a7b4",
  null
  
)

export default component.exports